import React, { useState } from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import Header2 from '../../Layout/Header/Header2';
import Blog2 from '../../widgets/main/Blog2';
import Gallerylist from '../../widgets/main/GalleryList';
import Counter2 from '../../widgets/main/Counter2';
import FeatureServices from '../../widgets/main/FeatureServices';
import Herosection8 from '../../widgets/main/Herosection8';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import image03 from '../../assets/images/blog/blog-thumb/03.png';
import constant from '../../constants.json';

function Index9() {
    return (
        <div>
            <Header2 />
            <section>
                <div className="container">
                    <Herosection8 />
                </div>
            </section>
            <div className="page-content">
                <section>
                    <div className="container ps-8 pe-8">
                        <div className="row justify-content-center text-center">
                            <div className="col-12 col-md-12 col-lg-8 mb-8 mb-lg-0 ">
                                <div className="mb-8"> <span className="badge badge-primary-soft p-2 font-w-6">
                                    Our Services
                                </span>
                                    <h2 className="mt-3 font-w-5">Your Vision, Our Code — Innovating Together</h2>
                                    <p className="lead mb-0">Bringing Your Ideas to Life at Competitive Rates, Global Standards</p>
                                </div>
                            </div>
                        </div>
                        {/* / .row */}
                        <FeatureServices />
                    </div>
                </section>
                <section>
                    <div className="container ps-8 pe-8">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-12 col-lg-6 mb-6 mb-lg-0 order-lg-1">
                                <div className="row align-items-center">
                                    <div className="col-7">
                                        <img src={require(`../../assets/images/hero/11.jpg`)} className="img-fluid rounded shadow-lg" alt="..." />
                                    </div>
                                    <div className="col-5">
                                        <img src={require(`../../assets/images/hero/14.jpg`)} className="img-fluid rounded shadow-lg mb-4" alt="..." />
                                        <img src={require(`../../assets/images/hero/10.jpg`)} className="img-fluid rounded shadow-lg mt-1" alt="..." />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 col-xl-5">
                                <div>
                                    <span className="badge badge-primary-soft p-2 font-w-6">
                                        What We Offered
                                    </span>
                                    <h2 className="mt-3 font-w-5 mb-0">We Provide Services, Not Products</h2>
                                    <p className="lead">Tailor-made software based on your needs</p>
                                    <div className="mt-5 d-flex flex-wrap justify-content-start">
                                        <div className="col-6">
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">Company Website</p>
                                                </div>
                                            </div>
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">Integrated System</p>
                                                </div>
                                            </div>
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">Stock Management</p>
                                                </div>
                                            </div>
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">Management System</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">Logistics Tracking</p>
                                                </div>
                                            </div>
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">Operational Dashboard</p>
                                                </div>
                                            </div>
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">Customer Management</p>
                                                </div>
                                            </div>
                                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                                <div className="d-flex align-items-center">
                                                    <div className="badge-primary-soft rounded p-1">
                                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-check">
                                                        <polyline points="20 6 9 17 4 12" />
                                                        </svg>
                                                    </div>
                                                    <p className="mb-0 m-1">... and many more</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </section>
                
                    <section>
                        <div className="container ps-8 pe-8">
                            <div className="row align-items-end mb-0">
                                <div className="col-12 col-md-12 col-lg-4">
                                    <div> <span className="badge badge-primary-soft p-2 font-w-6">
                                        Portfolio
                                    </span>
                                        <h2 className="mt-3 font-w-5 mb-0">We’ve done lot’s of work, Let’s check some here</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-md-12 col-lg-8">
                                    <div>
                                        <p className="lead mb-0">All types of businesses need access to development resources, so we give you the option to decide how much you need to use.</p>
                                    </div>
                                </div>
                            </div>
                            <Gallerylist />
                        </div>
                    </section>
                <section>
                    <div className="container-fluid">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-12 col-lg-6 mb-8 mb-lg-0 position-relative">
                                <img src={require(`../../assets/images/about/05.png`)} alt="testimage" className="img-fluid" />
                            </div>
                            <div className="col-12 col-lg-6 col-xl-5">
                                <Counter2 />
                            </div>
                        </div>
                    </div>
                </section>
                {/*<section className="pt-0">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-12 col-md-12 col-lg-8 mb-8 mb-lg-0">
                                <div className="mb-8"> <span className="badge badge-primary-soft p-2 font-w-6">
                                    Latest News
                                </span>
                                    <h2 className="mt-3 font-w-5">From Our Blog List Latest Feed</h2>
                                    <p className="lead mb-0">All types of businesses need access to development resources, so we give you the option to decide how much you need to use.</p>
                                </div>
                            </div>
                        </div>
                        <Blog2 />
                    </div>
                </section>*/}
                <div className="App">
                  <FloatingWhatsApp
                    phoneNumber="123456789"
                    accountName={constant.APP_NAME}
                    statusMessage="Online few minutes ago"
                    chatMessage="Hi there! How can we help your business?"
                    avatar={image03}
                    allowEsc
                    allowClickAway
                    notification
                    notificationSound
                  />
                </div>
            </div>
        </div>
    )
}

export default Index9;